import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

// interfaces
import { IPedido, IPedidoDetall } from 'src/app/interfaces/pedido';

// servicios
import { RepartosService } from 'src/app/services/datos/repartos.service';
import { EanLabelsService } from 'src/app/services/ean-labels.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-pedido-detall',
  templateUrl: './pedido-detall.component.html',
  styleUrls: ['./pedido-detall.component.scss']
})
export class PedidoDetallComponent implements OnInit {
  @Input() pedidoDetall: IPedido = {} // Detalle de un pedido  
  @Input() eanSeleccionado: string = '';
  //@Input() articuloDetall: any = {} // Detalle de un artículo en un pedido

  loading: boolean = false;
  public articuloDetall: any[] = [];
  public articData: any = null;
  public stockData: any = null;

  public fotoDir: string = environment.fotoDir;
  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';

  imagenSeleccionada: string | null = null;

  colArticulosLabel = [
    { key: 'artSku', label: 'SKU' },
    { key: 'artEan', label: 'Ean' },
    { key: 'artDescripcion', label: 'Descripción' },
    { key: 'cantidad', label: 'Cantidad', style: { 'text-align': 'center', 'padding-left': '10px', 'white-space': 'nowrap', 'width': '1px' } },
    { key: 'cant_repartir', label: 'A Repartir', style: { 'text-align': 'center', 'padding-left': '10px', 'white-space': 'nowrap', 'width': '1px' } },
    { key: 'cant_repartida', label: 'Preparado', style: { 'text-align': 'center', 'padding-left': '10px', 'white-space': 'nowrap', 'width': '1px' } }
  ];
  sortColumnArt: string = '';
  sortDirectionArt: 'asc' | 'desc' = 'asc';


  constructor(
    private repartosSrv: RepartosService,
    private notificacionesSrv: NotificacionesService,
    public eanLabelsSrv: EanLabelsService
  ) { }

  ngOnInit(): void {
    // this.leerTextoConVoz('Hola mundo!');  
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pedidoDetall']) {
      // Si cambia el pedido, resetea los detalles del artículo 
      this.articuloDetall = [];
    }
  }


  infoArticuloPedido(pedidoDetall: IPedidoDetall) {
    this.loading = true;
    this.articuloDetall = [];

    this.articData = pedidoDetall;
    const data = {
      id_pedido: this.articData.id_pedido,
      id_articulo: this.articData.id_articulo,
      addStockData: true
    };
    this.repartosSrv.pedidoCajasRepartoDetall(data).subscribe(resp => {
      this.loading = false;
      console.log('__infoArticuloPedido() articData', this.articData);
      console.log('__infoArticuloPedido() resp', resp);

      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje || 'Error desconocido');
        this.articuloDetall = [];
        return
      }
      this.articuloDetall = resp.data || [];
      this.stockData = resp.totales.stockData;
    })

  }

  // AUX 

  hasArticuloDetall(): boolean {
    return Array.isArray(this.articuloDetall) && this.articuloDetall.length > 0;
  }

  get contaCajas(): number {
    return this.articuloDetall.length;
  }

  get sumaCantidad(): number {
    return this.articuloDetall.reduce((acc, d) => acc + (parseFloat(d.cantidad) || 0), 0);
  }


  leerTextoConVoz(txtVoz: string): void {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(txtVoz);
    synth.speak(utterance);
  }




  // Modal imágen
  abrirPopupImagen(url: string) {
    console.log('__abrirPopupImagen()', url);
    if (url.includes('_noFoto')) return
    this.imagenSeleccionada = url;
  }

  cerrarPopupImagen() {
    this.imagenSeleccionada = null;
  }

  ordenarArticulosCol(columna: string) {
    if (this.sortColumnArt === columna) {
      this.sortDirectionArt = this.sortDirectionArt === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnArt = columna;
      this.sortDirectionArt = 'asc';
    }

    if (this.pedidoDetall && this.pedidoDetall.detall) {
      this.pedidoDetall.detall.sort((a, b) => {
        let valueA = (a as any)[columna];
        let valueB = (b as any)[columna];

        // Convertir a número si ambos son numéricos y ambos son enteros
        const isNumeric =
          !isNaN(parseFloat(valueA)) && !isNaN(parseFloat(valueB));
        const isInteger =
          Number.isInteger(parseFloat(valueA)) &&
          Number.isInteger(parseFloat(valueB));
        if (isNumeric && isInteger) {
          valueA = parseFloat(valueA);
          valueB = parseFloat(valueB);
        } else {
          valueA = String(valueA).toLowerCase();
          valueB = String(valueB).toLowerCase();
        }

        if (valueA < valueB) return this.sortDirectionArt === 'asc' ? -1 : 1;
        if (valueA > valueB) return this.sortDirectionArt === 'asc' ? 1 : -1;
        return 0;
      });
    }
  }


}
